var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-flotante"},[_c('ModeSwitch',{}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-WhatsApp"},[_c('i',{staticClass:"fa-brands fa-whatsapp p-1"})])
}]

export { render, staticRenderFns }